/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryNoteInPoolArray } from '../../models/delivery-note-in-pool-array';
import { KeyType } from '../../models/key-type';

export interface GetDeliveryNotesMetadataInPool$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function getDeliveryNotesMetadataInPool(http: HttpClient, rootUrl: string, params: GetDeliveryNotesMetadataInPool$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteInPoolArray>> {
  const rb = new RequestBuilder(rootUrl, getDeliveryNotesMetadataInPool.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryNoteInPoolArray>;
    })
  );
}

getDeliveryNotesMetadataInPool.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes';
